import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    ViewChild,
    Output,
    EventEmitter,
    OnChanges,
    SimpleChanges,
} from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { EntitySelectorEntity, EntitySelectorObject } from 'app/shared/models/entities';
import { UptimeReportItem } from 'app/shared/models/uptime';
import { HydrographTickInterval } from 'app/shared/models/view-data';
import { MultiSelectAutoCompleteComponent } from 'app/shared/components/multi-select/multi-select-auto-complete/multi-select-auto-complete.component';
import { SampleRateElement } from '../uptime-overview/uptime-overview.component';
import { TrackBy } from 'app/shared/utils/track-by';
import { Selectable } from 'app/shared/models/selectable';
import { MatLegacySelectChange } from '@angular/material/legacy-select';

export interface DateRange {
    startDate: Date;
    endDate: Date;
}

@Component({
    selector: 'app-uptime-filters',
    templateUrl: './uptime-filters.component.html',
    styleUrls: ['./uptime-filters.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class UptimeFiltersComponent implements OnInit, OnChanges {
    @ViewChild(MultiSelectAutoCompleteComponent) locationsSelect: MultiSelectAutoCompleteComponent;
    @Output() dateRangeChange = new EventEmitter<DateRange>();
    @Output() locationSelected = new EventEmitter<Selectable[]>();
    @Output() entitiesChange = new EventEmitter<number[]>();
    @Output() sampleRateChange = new EventEmitter<MatLegacySelectChange>();
    @Output() applyFilters = new EventEmitter<boolean>();
    @Input() availableEntities: EntitySelectorObject[];
    @Input() defaultEntities: EntitySelectorObject[];
    @Input() uptimeData: UptimeReportItem[];
    @Input() startDate: Date;
    @Input() endDate: Date;
    @Input() selectedEntityIds: number[] = [];
    @Input() selectedLocations: Selectable[] = [];
    @Input() selectedSampleRate: number;
    @Input() locationsList: Selectable[];
    @Input() sampleRateList: SampleRateElement[];
    public locationsAutoComplete: string;
    public filteredLocations: Selectable[] = [];
    public sampleRList: SampleRateElement[];
    public isSearching = false;
    public tickInterval: HydrographTickInterval;
    public separatorKeysCodes: number[] = [ENTER, COMMA];

    public selected: number = 2;

    public maxDate = new Date();
    public trackById = TrackBy.byId;
    constructor() {}

    ngOnInit() {
        this.filteredLocations = [...this.locationsList];
        this.sampleRList = [...this.sampleRateList];
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.locationsList) {
            this.filteredLocations = [...changes.locationsList.currentValue];
            this.selectedLocations = this.selectedLocations.filter((v) =>
                this.filteredLocations.find((i) => v.id === i.id),
            );

            if (this.locationsSelect) {
                this.locationsSelect.items = this.filteredLocations;
                this.locationsSelect.preselectedItems = this.selectedLocations;
                this.locationsSelect.updateOnSelectedChange();
            }
        }
    }

    public selectSearchBox() {
        this.locationsAutoComplete = '';
        this.filterEntities();
        this.isSearching = true;
    }

    public searchBoxStringEntered() {
        this.filterEntities(this.locationsAutoComplete.toLowerCase());
    }

    public onDatePickerClose() {
        this.dateRangeChange.emit({ startDate: this.startDate, endDate: this.endDate });
    }

    public selectedEntities(event: EntitySelectorEntity[]) {
        this.entitiesChange.emit(event.map((v) => v.id));
    }

    public selectedSampleR(sampleRate: MatLegacySelectChange){
        this.sampleRateChange.emit(sampleRate);
    }


    public handleSelectedLocations(event: Selectable[]) {
        const selected = event.filter((v) => v.isChecked);
        this.locationSelected.emit(selected);
    }

    private filterEntities(searchString?: string) {
        if (!searchString) {
            this.filteredLocations = [...this.locationsList];
            return;
        }

        this.filteredLocations = this.locationsList.filter((v) =>
            v.name.toLowerCase().includes(searchString.toLowerCase()),
        );
        this.filteredLocations = this.filteredLocations.filter(
            (v) => !this.selectedLocations.find((i) => i.id === v.id),
        );
    }

    public btnApplyFilters() {
        this.applyFilters.emit(true);
    }
}
